import { Component, EventEmitter, Input, OnInit, OnDestroy, Output } from '@angular/core';

import { Observable ,  Subscription ,  Subject, of } from 'rxjs';

import { WindowRefService } from '../../../shared/services/window-ref/window-ref.service';
import { switchMap, delay } from 'rxjs/operators';
import { EnvironmentService } from '../../services/environment/environment.service';

@Component({
  selector: 'app-background',
  templateUrl: './background.component.html',
  styleUrls: ['./background.component.scss']
})
export class BackgroundComponent implements OnInit, OnDestroy {

    @Input() images: string[];
    @Input() delay: number;

    @Output() loaded = new EventEmitter();

    items: {
        src: string,
        id: number,
        zIndex: number
    }[];

    index: number = -1;
    previousIndex: number = -2;
    round = 1;

    private timer$: Subject<void> = new Subject<void>();

    private firstLoad: boolean = true;
    private subscription = Subscription.EMPTY;

    constructor (
        private window: WindowRefService,
        private ennvironmentService: EnvironmentService) {}

    ngOnInit() {
        if (this.images && this.images.length) {
            this.start();
        }
    }

    ngOnDestroy () {
        this.stop();
    }

    onImageError (event: { value: number }) {
        // remove item from array
        this.items = this.items.filter((item) => {
            return item.id !== event.value;
        });
        // ensure index is still valid
        this.validateIndex();
    }

    onTransitionIn (event: { value: number }) {
        // tell the parent that the first image is ready
        if (event.value === 0 && this.firstLoad) {
            this.firstLoad = false;
            this.loaded.emit();
        }

        // emit event to start the next timer
        this.timer$.next();
    }

    private start () {
        // shuffle the items and map them to the properties
        this.items = this.shuffle(this.images).map((src: string, index: number) => {
            return {
                src: this.ennvironmentService.getEnvironment().cdn.url + src,
                id: index,
                zIndex: index
            };
        });

        if (this.items.length > 1) {
            // start tick
            this.subscription = this.timer$.asObservable().pipe(
                switchMap(() => {
                    // when a new transitionIn event occurs we start our timer
                    return of(true).pipe(delay(this.delay));
                }))
                .subscribe(() => {
                    this.tick();
                });

            // init
            this.tick();

        } else {
            this.index = 0;
        }
    }

    private tick () {
        let nextIndex = this.index + 1;

        // reset to beginning when we reach the end
        if (nextIndex > this.items.length - 1) {
            nextIndex = 0;
            this.previousIndex = this.items.length - 1;
            this.round++;
        } else {

            this.index = nextIndex;
            this.previousIndex = nextIndex - 1;

        }

    }

    private stop () {
        this.subscription.unsubscribe();
    }

    private shuffle (array: any[]) {
        const a = array.slice();
        for (let j, x, i = a.length; i; j = Math.floor(Math.random() * i), x = a[--i], a[i] = a[j], a[j] = x);
        return a;
    }

    private calculateNextIndex () {
        let nextIndex = this.index + 1;

        // reset to beginning when we reach the end
        if (nextIndex > this.items.length - 1) {
            nextIndex = 0;
            this.round++;
        }

        return nextIndex;
    }

    private validateIndex () {
        if (this.index >= this.items.length) {
            this.index = 0;
            this.previousIndex = this.items.length - 1;
            this.round++;
        }
    }
}
